// extracted by mini-css-extract-plugin
module.exports = {"feedback-text":"AuthCannyPage_feedback-text__cW-mA"};